const pagesDeviceProfileMdmEn = {
  emptyState: {
    action: 'Add integration',
    description:
      'Connect your MDM software (Intune or LANSCOPE) to view device management information here.',
    title: 'No MDM software integrated.',
  },
};

export default pagesDeviceProfileMdmEn;
